import React, { createContext, useState, useEffect } from "react";
import axiosMain from "../InsocialOrbit/http/axiosMain";
import { toast, ToastContainer } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

// Create the context
export const GlobalContext = createContext();

// Create the GlobalProvider component
export const GlobalProvider = ({ children }) => {
  const [authToken, setAuthToken] = useState(null);
  const [userData, setUserData] = useState(null);
  const [isLogdin, setisLogdin] = useState(false);

  useEffect(() => {
    // const token = localStorage.getItem("authToken");
    // if (token) {
    axiosMain
      .get("/api/v1/me")
      .then((res) => {
        if (res.status === 200) {
          setisLogdin(res.data.isUserLoggedIn);
          setUserData(res.data.user);
          // setAuthToken(token); // Restore token if it's saved in localStorage
        }
      })
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          toast.error("Please login", {
            position: "top-right",
            autoClose: 3000,
          });
        } else {
          toast.error("Something went wrong", {
            position: "top-right",
            autoClose: 3000,
          });
          console.log("Error:", err);
        }
      });
    // }
    // Optionally, you can load user data here from localStorage or an API if you store it
  }, []);

  // Function to login (set auth token and store in localStorage)
  const login = (token, userData) => {
    localStorage.setItem("authToken", token); // Store the token in localStorage
    setAuthToken(token); // Set auth token in state
    setUserData(userData); // Store user data (if you want to use it globally)
  };

  // Function to logout (remove auth token and user data)
  const logout = () => {
    localStorage.removeItem("authToken");
    setAuthToken(null); // Clear the token
    setUserData(null); // Clear user data
  };

  // Global state that can be accessed by any component
  return (
    <GlobalContext.Provider
      value={{
        authToken,
        userData,
        login,
        logout,
        isLogdin,
        setisLogdin,
        setUserData,
      }}
    >
      {children}
      {/* <ToastContainer position="top-right" autoClose={3000} /> */}
    </GlobalContext.Provider>
  );
};
